export default __webpack_public_path__ + "static/media/Ellipse 30.b544b5d1.svg";